import getEnabledItems from '@lyearn/core/utils/array/getEnabledItems';
import { TFunction } from '@lyearn/i18n';
import { PersonEdit, PersonOutline, PlugOutline } from '@lyearn/icons';
import { Image } from '@/components/Image';
import { SharedConnectionInfo, WorkspaceDetails } from '@/types/schema';

import { ShareMenuActions } from '../types';

export const getWorkspaceIcon = (
  workspaceOrConnection: WorkspaceDetails | SharedConnectionInfo,
): string => {
  return workspaceOrConnection.icon || workspaceOrConnection.workspaceLogo!;
};

export const getWorkspaceGroup = (availableInWorkspaces?: WorkspaceDetails[] | null) => {
  return [
    {
      id: 'workspaceId',
      options:
        availableInWorkspaces?.map((workspaceDetail) => ({
          value: workspaceDetail.workspaceId,
          label: workspaceDetail.workspaceName,
          Icon: () => (
            <Image
              alt={workspaceDetail.workspaceName}
              className="h-20 w-20"
              height={20}
              objectFit="contain"
              src={getWorkspaceIcon(workspaceDetail)}
              width={20}
            />
          ),
        })) ?? [],
    },
  ];
};

const getShareMenuItems = ({
  t,
  showLyearnConnect,
  showLearnerLink,
}: {
  t: TFunction;
  showLyearnConnect: boolean;
  showLearnerLink?: boolean;
}) =>
  getEnabledItems([
    {
      id: ShareMenuActions.ShareLearnerLink,
      label: t('Common:CopyLearnersLink'),
      EndIcon: PersonOutline,
      enabled: showLearnerLink,
    },
    {
      id: ShareMenuActions.ShareStaffLink,
      label: t('Common:CopyStaffLink'),
      EndIcon: PersonEdit,
      enabled: true,
    },
    {
      id: ShareMenuActions.ShareContent,
      label: t('Admin:ShareActions.ShareContent'),
      EndIcon: PlugOutline,
      enabled: showLyearnConnect,
    },
  ]);

export default getShareMenuItems;
